import timeFromNow from "../../services/timeFromNow";
import {
  PROJECT_REQUEST,
  PROJECT_FAIL,
  PROJECT_RESET,
  PROJECT_SUCCESS,
  PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
  CURRENT_BLOCK_UPDATE,
  PROJECT_OPTION_SUCCESS,
  PROJECT_CREDITS_UPDATE_SUCCESS,
  FONT_STYLE_UPDATE,
  FONT_STYLE_HISTORY_APPLY,
  SETTING_OPTION_STATE,
  PROJECT_FONTSTYLE_UPDATE_SUCCESS,
  PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
  PROJECT_LOGO_UPLOAD_SUCCESS,
  PROJECT_SETTINGS_UPDATE_SUCCESS,
  PROJECT_RENDER_REQUEST_SUCCESS,
  BLOCK_MOVE,
  RENDER_DELETE_SUCCESS,
  RENDER_DELETE_All_SUCCESS,
  CARD_PROJECT_SUCCESS,
  PROJECT_GLOBAL_OPTION_SUCCESS,
  USER_STRIPE_DATA_SUCCESS,
  PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS,
  CUSTOM_FONTS_LOAD_SUCCESS,
  PROJECT_STATUS_REALTIME_UPDATE,
} from "../actions/types";

const initialState = {
  credits: null,
  currentBlock: { idx: 0, id: null },
  customFonts: [],
  error: null,
  fontStyle: null,
  googleSheetLink: null,
  googleSpreadSheetId: null,
  isLoading: false,
  isVideoGenerated: null,
  lastSaved: null,
  lastSavedTime: new Date(),
  lastCreditsSyncedAt: null,
  logos: [],
  members: [],
  renders: [],
  resolution: null,
  settings: null,
  userStripeData: [],
};

const projectReducer = (state = initialState, action) => {
  // console.log(' state = ', state + ' action = ',action);
  switch (action.type) {
    case PROJECT_REQUEST:
      return { ...state, isLoading: true };

    // Drop the previously opened project; fonts and Stripe data belong to the user.
    case PROJECT_RESET:
      return {
        ...initialState,
        customFonts: state.customFonts,
        userStripeData: state.userStripeData,
      };

    case PROJECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case PROJECT_SUCCESS:
      const {
        _id,
        credits: _credits,
        members,
        googleSheetLink: _googleSheetLink,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        isVideoGenerated: _isVideoGenerated,
        renders,
        resolution,
        title,
        isCard,
        projectStatus,
        statusId,
        creditsIntroEligible,
        lastCreditsSyncedAt,
      } = action.payload;
      return {
        ...state,
        isLoading: false,
        _id,
        credits: _credits,
        members,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        googleSheetLink: _googleSheetLink,
        isVideoGenerated: _isVideoGenerated,
        lastSavedTime: new Date(),
        renders,
        resolution,
        title,
        isCard,
        projectStatus,
        statusId,
        creditsIntroEligible,
        lastCreditsSyncedAt,
      };

    case PROJECT_CREDITS_UPDATE_SUCCESS:
      return {
        ...state,
        credits: action.payload.credits,
        ...(action.payload.currentBlock && {
          currentBlock: action.payload.currentBlock,
        }),
        ...(Object.prototype.hasOwnProperty.call(
          action.payload,
          "lastCreditsSyncedAt",
        ) && { lastCreditsSyncedAt: action.payload.lastCreditsSyncedAt }),
        lastSavedTime: new Date(),
        isLoading: false,
      };

    case CURRENT_BLOCK_UPDATE:
      const { id, idx } = action.payload;
      let currentBlock = state.currentBlock;
      currentBlock = { ...currentBlock, id, idx };
      return {
        ...state,
        currentBlock,
      };

    //drag and drop reducer
    case BLOCK_MOVE:
      const { sourceIdx, targetIdx } = action.payload;
      const updatedCredits = [...state.credits];
      const [removed] = updatedCredits.splice(sourceIdx, 1);
      updatedCredits.splice(targetIdx, 0, removed);
      return {
        ...state,
        credits: updatedCredits,
      };
    //drag and drop end

    case PROJECT_CREDIT_OPTIONS_STATE_UPDATE:
      const { creditsIdx, optionKey, optionValue } = action.payload;
      const credits = [...state?.credits];
      if (optionValue === "sidebyside") {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "on",
        };
      } else if (
        credits[creditsIdx - 1]?.options?.block_inset === "sidebyside"
      ) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
      } else if (optionKey == "double_columns" && !optionValue) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
          ["text_alignment"]: "center",
        };
      }
      // Reset width only when switching columns → paragraph, not bullet shape.
      // Keep columns / column_width as numbers so 1 → 2 → 3 cannot miss the
      // strict-equality layout branches or leave a leftover 100% * N overflow.
      else if (optionKey == "bullets" && optionValue !== null) {
        const alreadyParagraph =
          credits[creditsIdx]?.options?.bullets != null;
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          columns: 1,
          ...(alreadyParagraph ? {} : { column_width: 100 }),
        };
      } else if (optionKey == "bullets" && optionValue === null) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          bullets: null,
          columns: 1,
          column_width: 100,
          side_by_side: "off",
        };
        if (credits.length - 1 !== creditsIdx) {
          credits[creditsIdx + 1].options = {
            ...credits[creditsIdx + 1]?.options,
            side_by_side: "off",
          };
        }
      }       else if (optionKey == "columns") {
        const newColumns = Math.max(1, Number(optionValue) || 1);
        const maxWidth = Math.round((100 / newColumns) * 2) / 2;
        const currentWidth = Number(credits[creditsIdx]?.options?.column_width);
        const nextWidth =
          Number.isFinite(currentWidth) && currentWidth > 0
            ? Math.min(currentWidth, maxWidth)
            : maxWidth;
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          columns: newColumns,
          column_width: nextWidth,
          side_by_side: "off",
        };
        if (credits.length - 1 !== creditsIdx) {
          credits[creditsIdx + 1].options = {
            ...credits[creditsIdx + 1]?.options,
            side_by_side: "off",
          };
        }
      } else if (credits.length - 1 === creditsIdx) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
      } else {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "off",
        };
      }
      return {
        ...state,
        credits,
      };

    case PROJECT_OPTION_SUCCESS: {
      const payload = action.payload;
      if (
        !payload ||
        typeof payload !== "object" ||
        Array.isArray(payload) ||
        !payload.creditsId ||
        !state.credits
      ) {
        return state;
      }
      const { options, creditsId } = payload;
      const _creditsIdx = state.credits.findIndex(
        (credit) => credit._id == creditsId
      );
      if (_creditsIdx === -1) return state;
      if (payload.preserveOptions) {
        return {
          ...state,
          isLoading: false,
          lastSavedTime: new Date(),
        };
      }
      return {
        ...state,
        credits: state.credits.map((credit, i) =>
          i === _creditsIdx ? { ...credit, options } : credit
        ),
        isLoading: false,
        lastSavedTime: new Date(),
      };
    }

    case PROJECT_GLOBAL_OPTION_SUCCESS:
      const { updatedOptions } = action.payload;
      const cardCredits = state.credits.map((credit) => ({
        ...credit,
        options: {
          ...credit.options,
          ...updatedOptions,
        },
      }));
      return {
        ...state,
        credits: cardCredits,
      };

    case PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS: {
      const { block_type, updatedProjectOptions } = action.payload;
      const isSideBySide = updatedProjectOptions?.block_inset === "sidebyside";
      return {
        ...state,
        credits: state.credits.map((credit, index) => {
          if (credit.options.block_type === block_type) {
            const block_inset = isSideBySide
              ? index % 2 === 0
                ? "sidebyside"
                : "default"
              : updatedProjectOptions.block_inset || credit.options.block_inset;
            return {
              ...credit,
              options: {
                ...credit.options,
                ...updatedProjectOptions,
                block_name: credit.options.block_name,
                heading: credit.options.heading,
                subheading: credit.options.subheading,
                block_inset,
              },
            };
          } else {
            // Return credit unchanged if it doesn't match the block_type
            return credit;
          }
        }),
      };
    }

    case SETTING_OPTION_STATE:
      const { settingsKey, settingsvalue } = action.payload;
      return {
        ...state,
        settings: {
          ...(state.settings ?? {}),
          [settingsKey]: settingsvalue,
        },
      };

    // Font-Update
    case FONT_STYLE_UPDATE:
      const { key, property, value } = action.payload;
      return {
        ...state,
        fontStyle: {
          ...state.fontStyle,
          [key]: { ...state.fontStyle[key], [property]: value },
        },
      };

    case FONT_STYLE_HISTORY_APPLY:
      return {
        ...state,
        fontStyle: action.payload,
      };

    // Font-Save
    case PROJECT_FONTSTYLE_UPDATE_SUCCESS:
      const {
        fontStyle: __fontStyle,
        fontStyleType,
        fontStyleBody,
        preserveLocalFontStyle,
      } = action.payload;
      return {
        ...state,
        fontStyle: preserveLocalFontStyle
          ? state.fontStyle
          : {
              ...state.fontStyle,
              [fontStyleType]: __fontStyle,
              fontStyleBody: fontStyleBody,
            },
        lastSavedTime: new Date(),
        isLoading: false,
      };

    // Logo Block Settings
    case PROJECT_LOGO_UPLOAD_SUCCESS:
      const { logos } = action.payload;
      return { ...state, logos, isLoading: false };

    case PROJECT_SETTINGS_UPDATE_SUCCESS:
      const {
        settings: __settings,
        preserveLocalSettings,
      } = action.payload;
      return {
        ...state,
        settings: preserveLocalSettings
          ? state.settings
          : { ...__settings },
        isLoading: false,
      };
    // Render
    case PROJECT_RENDER_REQUEST_SUCCESS:
      const { renders: _renders } = action.payload;
      return { ...state, renders: [..._renders], isLoading: false };

    case PROJECT_STATUS_REALTIME_UPDATE:
      if (String(state?._id) !== String(action.payload?.projectId)) {
        return state;
      }
      return {
        ...state,
        projectStatus: action.payload.projectStatus,
        statusId: action.payload.statusId,
      };

    case RENDER_DELETE_SUCCESS:
      const { renderId } = action.payload;
      return {
        ...state,
        renders: [
          ...state.renders.filter((project) => project._id !== renderId),
        ],
      };

    case RENDER_DELETE_All_SUCCESS:
      const { deleterenders } = action.payload;
      return {
        ...state,
        renders: deleterenders,
      };
    case USER_STRIPE_DATA_SUCCESS:
      return {
        ...state,
        userStripeData: action.payload,
        error: null,
      };

    case CUSTOM_FONTS_LOAD_SUCCESS:
      return {
        ...state,
        customFonts: action.payload.fonts,
      };

    // Old Project Logo Upload State
    case PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS:
      const { creditsId: _creditsId, items, dataSaved } = action.payload;
      const __creditsIdx = state.credits.findIndex(
        (credit) => credit._id === _creditsId
      );
      if (__creditsIdx === -1) return state;
      state.credits[__creditsIdx].items = items;
      return {
        ...state,
        credits: [...state.credits],
        lastSavedTime: dataSaved ? new Date() : state.lastSavedTime,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default projectReducer;
